class BoxedText {
    constructor(context, settings, $) {
        this.context = context;
        this.settings = settings;
        this.$ = $;
        this.$window = this.$(window);

        this.$boxedText = this.$('.js-boxed-text', this.context).once();

        if (this.$boxedText.length) {
            if (
                "IntersectionObserver" in window &&
                "IntersectionObserverEntry" in window &&
                "intersectionRatio" in window.IntersectionObserverEntry.prototype
            ) {
                this.outlineEffect();
            } else {
                this.$boxedText.addClass('is-outlined');
            }
        }
    }

    outlineEffect() {
        // Fire when the block is 50% visible
        const config = {
            threshold: 0.5
        };

        let observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // When intersecting, add class
                    this.$(entry.target).addClass('is-outlined');

                    setTimeout(() => {
                        this.$(entry.target).addClass('animation-complete');
                    }, 2000);
                }
            });
        }, config);

        this.$boxedText.each((index, element) => {
            observer.observe(element);
        });
    }
}

export default BoxedText;
